<div [ngClass]="getBackgroundClass()" class="kh-gap-box" (click)="onStudentGapBoxClick()">
  <div class="kh-gap-box-header pointer">
    <div class="kh-gap-box-title kh-title-lg kh-text-primary" data-testid="gap-box-title">{{ title }}</div>
  </div>

  <div class="kh-gap-box-body kh-text-primary kh-body-md pointer">
    <div class="kh-percentage-container">
      <kh-img class="badge-img" [path]="isAssigned ? 'impact-portal/ShortLearningCycle_Logo.png' : 'class-badge-none-lg.png'" khA11yHidden></kh-img>
      <p class="kh-gap-box-percentage" data-testid="gap-box-percentage">
              {{ 'STUDENT_GAP_BOX.STUDENT_PERCENTAGE_STRUGGLING' | translate:{ studentPercentage: studentPercentage } }}
      </p>
      <div class="chevron-icon">
        <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
      </div>
    </div>
  </div>

  <div class="kh-gap-box-footer">
    <a (click)="onLearnMore($event)" class="kh-gap-box-learn-more kh-text-link-secondary">{{ 'STUDENT_GAP_BOX.LEARN_MORE' | translate }}</a>
    <button class="kh-secondary-button" [disabled]="isAssigned" (click)="onAssignExtraPractice($event)" [ngClass]="{'disabled-button': isAssigned}">
      <span *ngIf="!isAssigned" data-testid="assign-post-assessment-button">{{ 'STUDENT_GAP_BOX.ASSIGN_POSTASSESSMENT' | translate }}</span>
      <span *ngIf="isAssigned" data-testid="assigned-button"><fa-icon class="mr-1" [icon]="['fas', 'check']"></fa-icon>{{ 'STUDENT_GAP_BOX.ASSIGNED' | translate }} </span>
    </button>
  </div>
</div>
